import ScribeTextElementModel from 'js/models/ScribeTextElementModel';

export function isTextElementsChanged(
  newTextElements: ScribeTextElementModel[],
  prevTextElements: ScribeTextElementModel[]
) {
  if (newTextElements.length !== prevTextElements.length) return true;
  for (let i = 0; i < newTextElements.length; i++) {
    const prevTextElement = prevTextElements.find(e => e.id === newTextElements[i].id);
    if (prevTextElement && prevTextElement.text === newTextElements[i].text) continue;
    return true;
  }
  return false;
}
